// extracted by mini-css-extract-plugin
export default {"title":"A--z","warning":"B--z","sizeOptionsLegendText":"C--z"};